let content = [
    {
      id: "general_trading_conditions",
      title: "일반 거래 조건",
      tabs: [
        {
          //id: "product_details",
          id:"tc-view-6",
          title: "상품 상세내용",
          content_before: `<p class="mb-5">
                           iFOREX는 통화 쌍(외환), 상품, 지수, 주식, ETF 및 암호화폐(문맥에 따라 "금융 상품", "상품", "레버리지 상품" 또는 "CFD")를 포함한 다양한 기초 자산(“기초 자산”)을 기반으로 한 CFD 레버리지 마진 거래에 대해 매우 경쟁력 있는 조건을 제공합니다.
                            <br><br>
                            <b>스프레드</b><br>스프레드는 거래 비용이며 매도(Ask) 가격과 매수(Bid) 가격의 차이입니다. 예를 들면, USD/JPY가 매도 가격 101.202와 매수 가격 101.222에 거래되고 있다면, 이 두 가격 간의 차이가 스프레드라고 불립니다. 이런 경우에 스프레드는 2핍입니다.
                            <br><br>
                            <b>증거금과 레버리지</b><br>레버리지 상품을 거래할 때, "증거금"은 귀하가 입을 수 있는 모든 손실을 충당하는 담보의 역할을 하는 한편, 귀하의 실제 계좌 가치보다 훨씬 더 큰 포지션을 보유하도록 허용하고 투자된 금액에 비해 큰 이익을 생성할 수 있는 가능성을 제공합니다.
                            <br><br>
                            레버리지는 양날의 검이며 귀하의 수익을 극대화 할 수 있습니다. 그러나 레버리지는 꼭 같은 정도로 귀하의 손실을 확대할 수도 있습니다. 그러나 귀하가 과도한 레버리지를 이용하는 경우, 손실 거래가 많은 수익을 발생하고 있는 거래들를 빠르게 상쇄시킬 수 있습니다. 레버리지 이용 거래는 높은 위험도를 가지고 있으며 모든 투자자들에게 적합한 것은 아닐 수 있습니다.
                            <br><br>
                            iFOREX 계좌 보유자로서, 귀하는 당사의 마이너스 잔고 보호(Negative Balance Protection) 프로그램을 사용할 수 있는 권한이 부여되며, 이것은 자신이 예치한 금액을 초과하여 손실을 입지 않을 수 있다는 것을 의미합니다. 그럼에도 불구하고, 작은 시장 움직임이 상당한 자금 손실로 귀결될 수 있습니다. 당사의 거래 플랫폼은 어떤 주문을 실행하기 전에 자동으로 귀하의 증거금 요건을 계산하며, 자금 인출 요청이 이루어지기 전에 가용한 자금 수준을 확인합니다.
                            <br><br>
                           증거금 요건은 거래의 개시/청산에 의해 또는 계좌에서 미결제 포지션을 가진 채 자금 인출을 요청함으로써 계좌에서의 위험노출액 증가에 달려 있습니다. 증거금 요건은 주어진 자산에서의 변동성, 유동성 및 가격 가용성에 따라 포지션의 잠재적 위험을 반영합니다. 
                        </p>
                        <span id="product_section"></span>
                            <p class="tc-inner-link"><a href="/거래-조건/통화">통화</a></p>
                            <p class="tc-inner-link"><a href="/거래-조건/원자재">원자재</a></p>
                            <p class="tc-inner-link"><a href="/거래-조건/지수">지수</a></p>
                            <p class="tc-inner-link"><a href="/거래-조건/주식">주식</a></p>
                            <p class="tc-inner-link"><a href="/거래-조건/etf">상장지수펀드(ETFs)</a></p>
                            <p class="tc-inner-link"><a href="/거래-조건/암호화폐">전자화폐</a></p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "trading_hours",
          id: "tc-view-2",
          title: "거래 시간",
          content_before: `<p>
                    유럽과 북미의 겨울 동안, 주 단위 거래는 일요일 22:05(GMT)에서 시작하여 금요일 21:00(GMT)까지 계속됩니다. 이 기간 동안의 일광 절약 시간 기간에는, 주 단위 거래가 일요일 21:05(GMT)에 시작해서 금요일 20:00(GMT)에 끝납니다. 시장 거래 시간은 공휴일 또는 예외적인 글로벌 이벤트로 발생할 수 있는 비정상적인 유동성 상황 때문에 달라질 수 있습니다. 개장 또는 폐장 시간도 유동성 및 위험 관리 고려사항 때문에 iFOREX로 인해 변경될 수 있습니다.
                    <br><br>
                    투자상품의 대부분은 중단없이 24시간 기준으로 거래되지만, 그러나 어떤 투자상품들은 아래 표에서 보는 바와 같이 특별한 거래 시간을 가지고 있다:
                </p>`,
  
          data_id: "TradingHours",

          products: {
            1:"통화 및 가상화폐",
            2:"원자재",
            3:"지수",
            4:"주식",
            5:"Metals",
            8:"ETF"
          },
          table_titles: [
            "시장",
            "거래 시간 (GMT)",
            "첫 번째 일일 휴장 시간(GMT)",
            "두 번째 일일 휴장 시간(GMT)",
            "데이터 유효기간 (GMT)"
          ],
          content_after: `<p>하가 찾고 있는 투자상품이 어떤 시장에 포함되어 있는지 잘 모르시겠습니까? <span class="tclink" target-tab="tc-view-6">시장 별 투자상품 전체 목록</span> 확인은 여기를 클릭하십시오.</p>`,
        },
        {
          //id: "holidays",
          id: "tc-view-4",
          title: "휴일",
          content_before: `<p>
                    모든 시장의 거래 시간과 휴일을 확인하시려면, 거래 시간 변경에 영향을 끼치는 이벤트 목록을 아래에서 확인하시기 바랍니다.<br>
                    iFOREX에서 당사는 최선의 노력을 함으로써 본 정보를 최신화합니다.<br>
                    상세 정보가 더 필요하신 경우, 언재든 본사의 거래 데스크로 문의해 주시기 바랍니다.
                    </p>`,
  
          data_id: "Holidays",
          table_titles: [
            "시장",
            "거래 중지 시간 (GMT)",
            "거래 재개 시간 (GMT)",
          ],
          content_after: `<p class="mt-4">귀하가 찾고 있는 투자상품이 어떤 시장에 포함되어 있는지 잘 모르시겠습니까? <span class="tclink" target-tab="tc-view-6">시장 별 투자상품 전체 목록</span> 확인은 여기를 클릭하십시오.</p>`,
        },
        {
          //id: "orders_and_execution",
          id: "tc-view-23",
          title: "주문과 체결",
          content_before: `<p>
          <b>주문 유형</b></p>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>시장가 주문</th>
                   <th></th>
                </tr>
                <tr>
                   <td>거래 개시</td>
                   <td>현재의 가용한 시장 가격으로 포지션을 개시하는 주문</td>
                </tr>
                <tr>
                   <td>거래 청산</td>
                   <td>현재의 가용한 시장 가격으로 포지션을 청산하는 주문</td>
                </tr>
             </tbody>
          </table>
          <table class="mb-4 table4">
             <tbody>
                <tr>
                   <th>지정가 주문</th>
                   <th></th>
                </tr>
                <tr>
                   <td>손실 정지</td>
                   <td>손실 정지는 현재 시장 가격보다 불리한 가격에서 거래를 개시하거나 청산하는 주문입니다</td>
                </tr>
                <tr>
                   <td>이익 주문(Take Profit)</td>
                   <td>이익 주문(Take Profit)은 현재 시장 가격보다 유리한 가격에서 거래를 개시하거나 청산하는 주문입니다</td>
                </tr>
             </tbody>
          </table>
          <p>
             <b>시장가 주문</b><br>시장 주문(거래 요청, 예: 거래 개시, 거래 마감)은 회사의 거래 플랫폼(고객 측)에 유효한 가격으로 체결됩니다. 단, 해당 가격은 회사의 서버에서 업데이트된 기초 가격에서 미리 정해진 허용 수준 내에 있고, 기초 가격이 거래 플랫폼(귀하가 보는 것이 귀하가 얻는 것입니다(What You See Is What You Get), 즉 WYSIWYG)에서 업데이트된 가격 위인지 아래인지와 관계 없다. 거래 플랫폼(고객 측)에서 업데이트된 가격이 예를 들면, 고객이 주문을 낸 시간과 주문이 접수되어 체결된 시간 사이에 기초 자산의 변동, 높은 시장 변동성 및 통신 지체 시간으로 인해 허용 수준을 초과할 경우, 주문은 거래 플랫폼에서 업데이트된 가격(시장 가격)과 다른, 회사의 서버에서 업데이트된 가격으로 대칭적으로 체결됩니다. 거래 플랫폼(고객 측)에서 업데이트된 가격과 회사의 서버에서 업데이트된 가격 사이에 상당한 차이가 있는 경우, 주문이 거부됩니다.
          </p>
          <p>
             <b>지정가 주문</b><br>지정가 주문 (미래 주문)은 회사 서버에 표시된 시장 가격으로 주문서에 표시된 가격 ( '슬리피지')과 다를 수 있습니다. 예를 들어 시장 변동성이 높고 시장 가격의 차이로 인해 서버에서 주문에 표시된 가격을 사용할 수없는 경우 슬리피지가 발생할 수 있습니다. 이 경우, 주문은 대칭적이고 투명한 방법 (대칭 슬리피지)으로 고객의 호의 여부에 관계없이 슬리피지의 방향에 관계없이 첫 번째 가용 가격으로 집행됩니다.<br><br>24 시간을 기준으로 거래되지 않는 상품(예: 주식, 지수 및 ETF CFD)은 일 단위로 시장 갭을 겪을 수 있으며 따라서 슬리피지에 더 취약합니다. 슬리피지는 마이너스 잔고 보호(Negative Balance Protection)에 영향을 미치지 않으므로 고객은 슬리피지가 발생하더라도 절대로 투자된 금액(수익을 얻은 경우 이익을 포함)을 초과하여 손실을 보지는 않을 것이라는 것을 유념하는 것이 중요합니다.
          </p>
          <p>
             <b>체결 지연</b><br>체결의 지연은 iFOREX 서버와 고객의 인터넷, 모바일 또는 기타 통신 간의 연결에서의 기술적인 문제와 같이 다양한 이유로 발생할 수 있으며, 이것은 "미체결 주문"으로 귀결될 수 있습니다. 연결 경로의 교란은 때때로 신호를 방해하여 거래자의 플랫폼과 iFOREX 서버 간의 데이터 전송의 지연을 초래함으로써 플랫폼이 작동되지 않을 수 있습니다.
          </p>
          <p>
             <b>미체결 주문</b><br>과도한 거래량 또는 통신 지연 기간 동안, 미체결 주문이 발생할 수 있으며, 이것은 지정가 주문을 냈지만 주문이 확인되고/처리되는 데 단지 시간이 걸린다는 것을 의미합니다. 과도한 거래량 또는 통신 지연의 기간 동안, 지정가 주문들의 대기열이 형성될 수 있습니다. 접수 주문에서의 그런 증가는 때때로 어떤 지정가 주문의 확인/처리에서 지연이 발생하는 상황을 야기할 수 있습니다. 어떤 경우에는, 포지션이 사실상 체결되었을 수도 있고 그 지연이 단지 고객측의 디스플레이에서 과도한 인터넷 트래픽으로 인해 발생할 수도 있습니다.<br><br>모든 주문을 오직 한 번에 입력하는 것이 필요하다는 것을 유념하십시오. 같은 주문을 여러 번 입력하는 것은 귀하의 컴퓨터를 느리게 하거나 잠그거나 무심코 원치 않는 포지션을 개시할 수 있습니다.
          </p>
              </p>`,
  
          data_id: "",
          content_after: "",
        },
        {
          //id: "negative_balance_protection",
          id: "tc-view-20",
          title: "마이너스 잔고 보호(Negative Balance Protection)",
          content_before: `<p class="">
                iFOREX의 마이너스 잔고 보호(Negative Balance Protection) 방침은 고객의 손실이 고객의 계정에서 투자된 자금에 한정되도록 보장합니다. 본 방침에 따라, 고객은 iFOREX와 거래할 때 절대로 거래 손실로 인한 차변 잔액을 당하지 않게 되며 고객의 잠재 손실은 고객 계정에 예치된 자금과, 만약 있다면, 고객이 수익을 거둔 자금에 한정될 것입니다.
              </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "bonus_terms_and_conditions",
          id:'btc',
          title: "보너스 이용 약관과 조건",
          content_before: `
          <p><b>서문</b><br>본 보너스 약관은 아래에 자세히 설명된 바와 같이 회사가 제공하는 환영 보너스를 포함한 트레이딩 보너스, 캐쉬백 보너스 및 평가판 계정 보너스 (이하 '보너스'라고 함)와 관련되며 회사 약관의 필수 부분으로 간주됩니다. 해당 문서에 포함된 용어에 대한 모든 해석은 회사 웹 사이트에서 제공되는 회사 이용 약관에 근거하여 해석됩니다 <a href="/">kr.iforex.com</a>.</p>
          <p>
             <b>자격 조건</b><br>전적으로 회사 재량에 따라 수시로 수정되는 요구 사항에 맞춰 필요한 모든 등록 절차를 통과하여 본사가 적격 고객으로 승인한 고객에 한해 지급됩니다. (이하 '<b>적격 고객</b>')
             <br><br>
             회사 재량에 따라 적절하다고 판단되는 모든 고객 및/또는 국가/지역에 보너스를 제공합니다.
             <br><br>
             회사는 단독 재량에 따라 적격 고객을 포함한 모든 사용자의 보너스 지급을 거부할 수 있으며 절대 재량에 따라 보너스 프로모션을 철회할 수있는 권리를 가집니다.<br><br>미국 거주자를 포함한 제한된 사법권을 형성하는 지역의 거주자는 트레이딩 보너스를 지급받을 수 없습니다.
          </p>
          <p><b>트레이딩 보너스</b><br>일반 약관에 따라 거래 보너스는 적격 고객에게 거래 계정에 예치된 자금의 백분율로 지급되거나 회사가 단독 재량에 따라 적합하다고 판단하는 경우 부여됩니다.
             <br><br>
             거래 보너스는 마진 거래 목적으로만 지정되므로 추가 마진으로만 사용할 수 있습니다(즉, 고객은 부여된 보너스를 출금할 수 없습니다).
             <br><br>
             거래 보너스는 각 적격 고객별로 부여됩니다.
             <br><br>
             환영 보너스 - 첫 입금자를 위한 트레이딩 보너스입니다.
          </p>
          계좌 입금에 따라 트레이딩 보너스가 지급되는 경우 다음 조건이 적용됩니다.
                      <br>
                      <ol>
                      <li class="mb-0 mt-1">자본을 완전히 출금하는 경우 - 트레이딩 보너스 전부가 삭제됩니다.</li>
                      <li>지본 일부 출금의 경우 - 거래 보너스 금액은 출금 후 계정에 남아 있는 금액의 20%로 조정되거나 회사의 단독 재량에 따라 결정됩니다.</li>
                      </ol>
          <u style="font-style:italic">예시</u><br><br>
          적격 고객은 $ 1,000의 입금에 대해 30 % 보너스를 받기로 회사와 동의했습니다. 적격 고객은 트레이딩 보너스로 $ 300 (예 : 입금액의 30 %)의 추가 마진을 받게됩니다.<br><br>해당 보너스는 다음과 같이 고객의 계정에 반영됩니다.
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>트레이딩 보너스</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          트레이딩 보너스는 어떤 경우에도 출금할 수 없습니다. 트레이딩 보너스를 사용하여 얻은 모든 이익은 회사의 출금 정책 및 관련 법률에 따라 적격 고객의 요청에 의해 출금됩니다. 트레이딩 보너스로 얻은 출금 가능한 수익은 고객 계정의 "잔액" 섹션 아래에 표시됩니다.
          <br><br>
          <u style="font-style:italic">예시</u><br><br>
          적격 고객은 $ 1,000의 입금에 대해 30 % 보너스를 받기로 회사와 동의했습니다. 적격 고객은 자신의 계정에 다음과 같은 자본과 잔액을 보유하고 있습니다.
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>트레이딩 보너스</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,300</td>
                      <td>$300</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">시나리오 A</u><br><br>
          고객이 입금액 전액 ($ 1,000)을 출금 요청했습니다. 트레이딩 보너스는 완전히 제거됩니다.<br><br>이는 다음과 같이 고객의 계정에 반영됩니다:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>트레이딩 보너스</th>
                   </tr>
                   <tr>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                      <td>$0</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">시나리오 B</u><br><br>
          고객이 $ 800 출금 요청하여 자본이 $ 200로 감소한 경우 트레이딩 보너스는 자산의 20 %, 즉 $ 40가 됩니다.
          <br><br>이는 다음과 같이 고객의 계정에 반영됩니다:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>트레이딩 보너스</th>
                   </tr>
                   <tr>
                      <td>$200</td>
                      <td>$200</td>
                      <td>$240</td>
                      <td>$40</td>
                   </tr>
                </tbody>
             </table>
          </div>
          계정이 7 주 연속 비활성 상태인 경우 모든 트레이딩 보너스는 취소됩니다.
          <br><br>
          <p><b>캐쉬백</b><br>
             캐쉬백 프로그램은 적격 고객의 계정에 해당 주에 달성한 거래량과 회사가 사전에 결정한 액수에 따라 매주 현금으로 크레딧을 제공합니다. ("보류 중인 보너스")<br><br>보류 중인 보너스는 특정 혹은 다수의 입금액의 백분율 또는 회사의 단독 재량에 따라 결정될 수 있습니다.
          </p>
          <u style="font-style:italic">예시</u><br><br>
          $ 1,000를 입금한 적격 고객은 거래량 $ 20,000,000에 대한 캐쉬백으로 입금액의 최대 40 %를 받을 수 있습니다. 이러한 고객은 보류 중인 보너스로 $ 400를 받게됩니다.<br><br>해당 보류 중인 보너스는 다음과 같이 고객의 계정에 반영됩니다.
          <div class="table-wrapper">
             <table class="table2 mt-3 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>보류 중인 보너스</th>
                      <th>거래량</th>
                      <th>요구되는 볼륨</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$400</td>
                      <td>$0</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          거래 플랫폼에 안내되어 있는 바와 같이 매주 고객의 주간 거래량에 따라 계산된 실현 캐쉬백(Realized CashBack)은 총 캐쉬백 금액 (보류 중인 보너스)에서 공제된 고객의 실제 주간 거래량 (USD)과 필요한 거래량 사이의 비율에 따라 고객의 계정에 적립됩니다. 고객은 주간 거래량에 따라 계산된 캐쉬백을 받을 자격이 있으며 보류 중인 보너스는 고객이 필요한 거래량을 충족한 후에만 지급됩니다. 캐쉬백 액수 (실현 캐쉬백)은 고객에게 할당된 보류 중인 보너스로 제한됩니다.<br><br>거래량은 '매매' (in and out)를 기준으로 계산됩니다. 즉, $ 1 백만 (또는 이에 상응하는 다른 통화) 포지션의 개시와 동일한 포지션의 청산은 총 $ 2 백만 (또는 다른 통화에 상응하는 금액)으로 계산됩니다.
          <br><br>
          <u style="font-style:italic">예시</u><br><br>
          <u style="font-style:italic">시나리오 A</u><br><br>
          이전 예시에 나온 적격 고객은 거래된 $ 5,000,000 당 $ 100 실현 캐쉬백을 제공받았습니다. 1 주일 후 그는 거래량$ 5,000,000를 달성했습니다. 따라서 실현 캐쉬백으로 $ 100가 보류 중인 보너스에서 자본으로 이동되었습니다.<br><br>이는 다음과 같이 고객의 계정에 반영됩니다:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>보류 중인 보너스</th>
                      <th>거래량</th>
                      <th>요구되는 볼륨</th>
                   </tr>
                   <tr>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$1,100</td>
                      <td>$300</td>
                      <td>$5,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          <u style="font-style:italic">시나리오 B</u><br><br>
          입금 후 2 주가 지난 뒤 해당 고객은 거래량 $ 5,000,000를 달성하고 $ 300의 수익을 올렸습니다. 따라서 실현 캐쉬백의 또 다른 $ 100이 보류 중인 보너스에서 자본으로 이동되었습니다.<br><br>이는 다음과 같이 고객의 계정에 반영됩니다:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>보류 중인 보너스</th>
                      <th>거래량</th>
                      <th>요구되는 볼륨</th>
                   </tr>
                   <tr>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$1,500</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                      <td>$20,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          자본에 입금된 실현 캐쉬백은 거래에 사용하여가 언제든지 출금할 수 있습니다. 실현 캐쉬백 금액을 투자하여 얻은 수익은 적격 고객의 경우 출금할 수도 있습니다.<br><br>캐쉬백 프로모션은 시간 제한이 있으며 고객은 보류 중인 보너스를 받은 날로부터 3개월 이내에 실현 캐쉬백을 받습니다. 고객은 추가 입금 시 추가 캐쉬백을 받을 자격이 주어집니다.
          <br><br>
          <u style="font-style:italic">예시</u><br><br>
          이전 예시에서 적격 고객은 300 달러의 수익과 지급받은 200 달러의 실현 캐쉬백 금액을 출금하기로 결정했습니다. 따라서 그는 총 $ 500의 출금을 요청했습니다. 나머지 $ 200의 캐쉬백 보너스는 자신의 계정에 보류 중인 보너스로 남아 있으므로 고객은 여전히 $ 1,000로 거래를 계속할 수 있으며 보류 중인 보너스를 실현 캐쉬백으로 전환할 수있는 2개월 반이 남았습니다.<br><br>이는 다음과 같이 고객의 계정에 반영됩니다:
          <div class="table-wrapper">
             <table class="table2 mt-4 mb-4 w-auto">
                <tbody>
                   <tr>
                      <th>잔고, 계정잔액</th>
                      <th>자본</th>
                      <th>유효마진</th>
                      <th>보류 중인 보너스</th>
                      <th>거래량</th>
                   </tr>
                   <tr>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$1,000</td>
                      <td>$200</td>
                      <td>$10,000,000</td>
                   </tr>
                </tbody>
             </table>
          </div>
          모든 캐쉬백은 계정 내 통화로 지급됩니다.
          <br><br>
          <p>
             <b>평가판 계정</b><br>
             회사 거래 조건에 따라 사용자는 거래 시 사용 가능한 미화 25 달러의 트레이딩 보너스(상기 설명된대로)가 포함된 평가판 계정을 제공받을 수도 있습니다.
             <br><br>
             평가판 계정이 만료되고 평가판 계정의 보류 중인 모든 거래는 첫 번째 거래가 이루어진 날로부터 3일 이내에 종료됩니다("평가판 기간"). US 25$(“이익”)를 초과하는 금액은 사용자가 회사의 등록 절차를 성공적으로 완료하고 최소 예치액 US 100$를 입금한 경우 증거금으로 사용되거나 사용자 명의의 은행 계좌로 출금할 수 있습니다. (i) 출금은 회사의 출금 절차의 적용을 받으며 이체 수수료가 추가로 적용될 수 있으며 (ii) 출금되지 않거나 거래 계정으로 이체되지 않거나 거래 목적을 위한 마진으로 사용된 이익분은 첫 거래를 시작한 날로부터 최대 14일 이내에 취소됩니다.
             <br><br>
             보너스는 회사 플랫폼에 처음으로 등록하고 위에 설명한 자격 기준을 충족한 고객에게만 제공됩니다. 가구/IP 주소 당 한번의 보너스가 지급됩니다.
          </p>
          <p>
             <b>일반 약관</b><br>
             회사의 재량에 따라 모든 형태의 불법, 불공정 및/또는 오용 거래 방법 또는 행위 (시장 위험을 감수하지 않고 트레이딩 보너스로부터 재정적으로 이익을 얻는 등의 거래 활동 패턴 및/또 고객 당 하나 이상의 계정을 개설, 운영 또는 관리하는 것을 포함하되 이에 국한되지 않음) 및 보너스 제도와 관련한 회사의 합의, 정책 및 조건 위반의 징후 또는 의심, 조작이 있을 경우 해당 계정 및 모든 관련 계정에 적립된 모든 보너스를 무효화합니다. 일부 특별한 경우, 회사는 이행된 모든 거래와/또는 발생한 이익 혹은 손실을 고객과 합의된 사항 및 관련 법률에 따른 권리를 훼손하지 않는 전제하에 무효화하고 취소할 수 있으며 모든 관련 계정을 차단할 수 있는 권리를 가집니다. 또한 회사는 상기 조치의 결과에 대해 책임을 지지 않습니다.
             <br><br>
             회사는 단독 재량를 가지고 적합하다고 판단될 경우 언제든 위에 언급된 보너스 또는 제안한 모든 측면을 변경, 수정, 일시 중지, 취소 또는 종료할 수있는 권리를 보유합니다.
          </p>
                      </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "margin_information",
          id:'tc-view-24',
          title: "증거금 정보",
          content_before: `
                      <p>
                      아래에 표시된 창은 계정의 증거금과 관련된 상세 정보를 제공합니다:
                      <div class="table-wrapper">
                         <table class="table3 mt-4 mb-4">
                            <tbody>
                             <tr>
                                  <td>자본</td>
                                  <td style="">4995</td>
                               </tr>
                               <tr>
                                  <td>사용된 마진</td>
                                  <td style="">2,500</td>
                               </tr>
                               <tr>
                                  <td>가용 증거금</td>
                                  <td style="">2,495</td>
                               </tr>
                               <tr>
                                  <td>마진 활용은</td>
                                  <td style="color:green">+50.05%</td>
                               </tr>
                               <tr>
                                  <td>유지 마진</td>
                                  <td style="">500</td>
                               </tr>
                               <tr>
                                  <td>넷엑스포저</td>
                                  <td>250000</td>
                               </tr>
                               <tr>
                                  <td>익스포저 커버리지</td>
                                  <td>+1.998%</td>
                               </tr>
                            </tbody>
                         </table>
                      </div>
                      <ul class="list-style-disc-small mb-3">
                         <li><b>사용된 마진</b> 은 고객님의 거래를 위한 마진으로 현재 사용중인 계정의 지본 금액을 보여줍니다. 사용된 마진이 자본보다 같거나 큰 경우 계정의 레버리지가 최대화 되었음을 나타냅니다. 휴장기간동안에는 일부 계좌의 요구 되는 마진 ( '종목 정보' 표에 자세히 설명 됨)이 증가합니다. 이는 사용 가능한 마진에 영향을 주며 그 결과로 주말에 급격히 감소 할 수 있습니다.
                        <br>사용 된 마진= 종목의 넷 익스포저 x 해당 종목의 필요한 마진</li>
                         
                         <li><b>가용 증거금</b> 은 계좌에서 현재 사용되고 있지 않은 순자산액이며 순 위험노출액의 추가 증가에 사용될 수 있습니다. 가용 증거금이 제로인 경우, 이것은 계좌에서의 최대 레버리지 이용을 나타냅니다.<br>가용 증거금 = 순자산액-사용된 증거금</li>

                         <li><b>마진 활용은</b> 계정의 현재 거래에 대한 증거금으로 사용중인 지분의 비율을 나타냅니다. 마진 활용이 100 % 이상이 되면, 계정에서 레버리지를 최대로 활용한 것으로 나타나게 됩니다.
                        <br>마진 활용 % = (사용된 마진/자본) X 100</li>
                         
                         <li><b>유지 마진</b>은 계정에서 개시되어 있는 거래를 유지하는 데 필요한 마진의 20%를 반영합니다. 계정의 자본이 유지 마진에 도달하거나 그 아래로 떨어지면 마진마감보호정책(아래 정의되어 있는대로)이 자동으로 활성화됩니다.
                         <br>
                         유지 마진 = 사용된 마진 X 거래 플랫폼에서 정의된 백분율(%)
                        <br>
                        iFOREX는 자사의 재량에 따라 유지 증거금을 설정 및/또는 변경할 권리는 있으나 의무는 없습니다.
                         </li>
                         <li><b>위험노출액 충당</b> 은 순위험노출액 중 몇 퍼센트가 순자산액에서 담보로 보유되는지를 보여 줍니다.
                         <br>
                         위험노출액 충당 = 순자산액/순위험노출액.

                         </li>
                      </ul>
                      <b>마진마감보호정책</b><br> 고객의 자본이 유지 마진 수준에 도달하거나 그 이하로 떨어지면 iFOREX는 가장 많은 양의 사용 마진을 소모하는 거래를 자동으로 마감하여 가능한 가장 낮은 유지 마진을 달성하고, 해당 거래 시간 동안 이용 가능한 상품에 대한 개시되어 있는 거래에만 영향을 미칩니다. 당시 개시되어 있는 거래가 없는 경우, 견적에 가장 먼저 받는 상품이 자동으로 마감됩니다. 가장 많은 사용 마진을 동일하게 소모하는 거래가 여러 개(하나 이상) 있는 경우, 회사는 먼저 열린 거래를 자동으로 마감합니다. 단일 거래의 자동 마감 가능한 가장 낮은 유지 마진을 달성할 수 없는 경우, iFOREX는 특정 상품에 대한 모든 개시되어 있는 거래를 자동으로 마감합니다.<br>
                     iFOREX는 고객이 개시되어 있는 거래에 실현되지 않은 이익을 최대한 활용하여 손실 거래를 지원할 수 있도록 합니다.  
                      <br><br>
                      <b><u><u>마진마감보호정책 관련 개시</u></u></b><br>
                      본 예시의 목적, 유지 마진 = 사용 마진 x 20%
                    <br><br>
                      <b>예시 I: 다중 거래(거래 보너스가 없는 경우)</b><br>
                      이 예는 여러 개의 개시되어 있는 거래가 있는 고객과 관련되어 있습니다. 계정의 자본은 유지 마진 수준으로 떨어집니다.<br><br>
                      <ul class="list-style-disc-small mb-3">
                         <li>거래 개시:</li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>1 USD/JPY 거래: 150.22의 비율로 200,000달러 매수(사용 마진 = 0.25% x 200,000달러 = 500달러)</li>
                            <li>1 금 거래: 2,300.00의 비율로 100온스 매수(사용 마진 = 0.5% x 100 x 2,300.00달러 = 1,150달러)</li>
                            <li>1 WTI 원유 거래: 70.00의 비율로 500배럴 매수(사용 마진 = 1% x 500 x 70달러 = 350달러)</li>
                         </ul>
                         <li>총 사용 마진: 2,000달러</li>
                         <li>유지 마진 레벨: 400달러</li>
                      </ul>
                      
                      <p><b>과정:</b></p>

                      <ol>
                        <li>계정의 자본이 400달러 이하로 떨어지면 시스템은 가장 많은 마진 (금)을 차지하고 있는 거래를 마감합니다. 이 경우 사용 마진이 850달러로 줄어들고 유지 마진은 170달러로 낮아집니다.</li>
                        <li>자본이 170달러 이하로 떨어지면 시스템은 USD/JPY 거래를 마감하고 사용 마진은 350달러로, 유지 마진은 70달러로 낮아집니다.</li>
                        <li>마지막으로 자본이 70달러 이하로 떨어지면 시스템은 마지막 남은 거래(WTI 원유)를 마감합니다.</li>

                      </ol>
                      <b>예시 II: 단일 거래(거래 보너스 포함)</b><br>
                      이 예시에는 미결제 거래 1건, 거래 보너스, 유지 증거금 이하의 자본을 보유한 고객이 포함됩니다.
                     <br><br>
                      <ul class="list-style-disc-small mb-3">
                        <li><b>입금</b>: $1,000(100% 거래 보너스 포함)</li>
                        <li><b>총 자본</b>: $2,000</li>
                        <li><b>개시 거래</b>: USD/JPY를 $800,000 매수</li>
                        <li><b>사용 마진</b>: 0.25% x $800,000 = $2,000</li>
                        <li><b>유지 마진 레벨</b>: $400</li>
                      </ul>
                      
                      <p><b>과정:</b> 자본이 -$600 이하로 떨어지면 총 자본 수준이 $400이 되고, 시스템은 유일하게 열려 있는 거래를 마감합니다.</p>
                      
                      <b>예시 III: 다중 거래(거래 보너스 포함)</b><br>

                      고객이 유지 증거금 이하의 거래 보너스와 자본을 제공하는 여러 개의 미결제 거래를 보유하고 있는 경우입니다.<br><br>

                      <ul class="list-style-disc-small mb-3">
                        <li><b>입금</b>: $1,000(100% 거래 보너스 포함)</li>
                        <li><b>총 자본</b>: $2,000</li>
                         <li><b>개시 거래:</b></li>
                         <ul class="list-style-disc-small empty-disc ml-4">
                            <li>1 USD/JPY 거래: 150.22의 비율로 $400,000 매수(사용 마진 = 0.25% x $400,000 = $1,000)</li>
                            <li>1 WTI 원유 거래: 85.00의 비율로 1,000배럴 매수(사용 마진 = 1% x 1,000 x $85 = $850)</li>
                         </ul>
                         <li><b>총 사용 마진</b>: $1,850</li>
                         <li><b>유지 마진 수준</b>: $370</li>
                      </ul>

                      <p><b>과정:</b></p>
                        <ol>
                            <li>자본이 -$630 이하로 떨어지면 총 자본이 $370이 되고 USD/JPY 거래가 종료됩니다.</li>
                            <li>USD/JPY 거래가 종료되면 사용된 마진은 $850이고 유지 마진 수준은 $170입니다($850 x 20%).</li>
                            <li>자본이 -$830(총 자본 = $170)으로 떨어지면 시스템은 WTI 원유 거래를 종료합니다.</li>
                        </ol>
                      
                      </p>`,
          data_id: "",
          content_after: "",
        },
        {
          //id: "additional_trading_rules",
          id: "tc-view-25",
          title: "추가적인 거래 규칙",
          content_before: `
              <p>
              <b>최대 위험노출액</b><br>
              더 나은 위험 관리와 한 단일 고객으로의 과도한 위험노출액을 피하는 데 맞추어진 신중한 조치로서, iFOREX는 고객당 미화로 최대 1천 5백만 달러까지 최대 순위험노출액 제한을 정했습니다. iFOREX은 또한 투자상품당 최대 순노출액을 정했습니다. 투자상품당 최대 순노출액을 보려면 <span class="tclink" target-tab="tc-view-6" target-section="product_section">여기를 클릭하십시오</span>. iFOREX는 단독 재량으로, 일체의 사전 고지 없이 언제든지 해당 제한을 취소하거나 변경할 권리를 가집니다.
              <br><br>
              <b>헤징</b><br>
              헤징은 동일한 시간이든 아니든, 동일 양이든 아니든 서로 다른 방향으로 동일한 투자상품 또는 기초 자산에 대한 두 가지 거래의 개시로 정의됩니다. iFOREX는 최소 증거금을 계산하려는 목적으로 누적 기준으로 또는 "순" 금액 기준으로 헤징 거래를 고려합니다. 더욱이, iFOREX는 헤지 거래들 중 하나의 청산을, 남은 거래 금액과 일치하는 금액으로 이어지는 새로운 거래의 개시로 간주합니다.
              <br><br>
              <b>거래의 상계</b><br>
              두 가지 이상의 거래가 한 계정에서 동시에 청산되는 경우, iFOREX는 모든 미결제 포지션을 하나의 전체로서 청산할 것입니다. 각 청산된 포지션에 배정된 거래 번호는 선입선출(FIFO) 규칙을 근거로 정해집니다. 이것은 거래의 청산 시에, 개시된 첫 포지션이 가장 낮은 거래 번호를 받게 되고 개시된 마지막 포지션이 가장 높은 거래 번호를 받게 된다는 것을 의미합니다.
              <br><br>
              <b>승인되지 않은 거래 방식</b><br>
              iFOREX는 공정한 거래를 지지하며 지연 거래, 가격 조작, 시간 조작 또는 불법적이고/거나 고객에게 불공정한 이익을 제공하기 위해 활용되는 일체의 기타 방식과 같이 남용 거래를 행사하는 방식을 허용하지 않습니다. 해당 금지 방식에 대한 예시는 다음 중 어떤 것이 될 수 있고 이에 국한되지 않습니다:
              <ul class="list-style-disc-small mt-3 mb-2">
                 <li>
                    <b>스캘핑</b>(Scalping)은 가격의 작은 변화를 활용하려는 거래 전략입니다. 이 전략을 구현하는 거래자는 많은 단기 포지션을 생성하고 일반적으로 몇 초 또는 몇 분 내에 해당 포지션을 마감합니다.
                 </li>
                 <li>
                    <b>자동화</b> (예: EA) 또는 알고리즘 거래는 변수가 시간, 가격 또는 주문 수량을 포함할 수 있는 사전 프로그램된 거래 지침을 실행하는 알고리즘으로 거래 주문을 입력하기 위한, 또는 많은 경우에 인간의 개입 없이 "로봇"에 의한 주문을 개시하기 위한 전자적 플랫폼의 사용입니다.
                 </li>
                 <li>
                    <b>API 거래</b> 는 응용프로그램 프로그래밍 인터페이스(Application Progrmming Interface) 거래로서, 다른 프로그램들과 상호작용하는 소프트웨어 프로그램을 사용하는 모든 거래를 의미합니다. API는 거래자와 시장 간의 중개자 역할을 하면서, 주문을 중계하고 필요한 정보를 검색합니다.
                 </li>
                 <li>
                    <b>‘복수 계좌’</b>는 한 명의 고객이 iFOREX로부터 부정하게 여러 개의 계좌와 관련한 이익을 얻으려는 목적으로 두 개 이상의 계좌를 보유한 상황을 의미합니다.
                 </li>
              </ul>
              <p>회사는 단독 재량에 따라 고객에게 불공정한 이점을 제공하기 위해 사용된 모든 형태의 착취, 불법, 불공정, 무단 및/또는 남용 거래 관행을 포함한 사기 행위, 회사와 맺은 계약, 정책 그리고 이용 약관의 조작 또는 위반의 징후가 있거나 의심되는 경우 고객과의 계약 및 해당 법률에 따른 권리를 훼손하지 않고 독자적이고 절대적인 재량에 따라 모든 것을 무효화하고 취소할 권리를 보유하고 있습니다. 관련 계정에서 발생한 모든 이익 또는 손실을 포함하여 관련 계정에서 수행된 거래와 고객에게 부여된 모든 보너스를 제거할 수 있으며 계정을 차단할 수 있습니다.</p>
              <b>가격의 오류</b><br>
              온라인 거래 기술은 완전하지 않으며 아주 드물게 입력이 중단될 수 있습니다. 이것이 잠시 동안만 지속될 수 있지만, 그런 일이 발생할 때 가격이 영향을 받게 될 수 있습니다. 온라인 거래 기술로 "차익 거래" 주문을 내려고 시도하는 동안, 가격들이 그런 상황에서 실제의 시장 가격을 반영하지 않고 귀하의 실제 입력이 표시된 가격에서 여러 핍 멀어질 수 있다는 점을 유의하십시오. 거래가 iFOREX에 의해 실제로 제공되지 않는 가격에서 체결되는 경우, iFOREX는 유효한 거래가 아니라고 고려되는 그런 거래들을 원래대로 되돌릴 권리를 보유합니다. 이런 경우는 대개 드물다는 것을 유념하십시오. 그리고 이런 순간에는 거래를 하지 않음으로써, 거래자들은 위의 시나리오와 관련된 위험을 피할 수 있습니다.
              <br><br>
              <b>금고</b><br>
              이 기능을 통해 고객은 계정 상 거래 활동에 영향을 받지 않고 계정에서 사용 가능한 자금을 제외할 수 있으며, 고객의 재량에 따라 계정의 거래 마진 상황에 따라 언제든지 복원할 수 있습니다. 금고의 사용은 회사의 단독 재량에 따라 회사 고객에게 허용됩니다. 고객이 금고를 사용할 경우 다음 조건이 적용됩니다: (i) 회사가 부여한 보너스는 금고에 예치될 수 없습니다. (ii) 고객 계정으로 자금을 다시 복원하는 것은 금고에 예치된 합계에 따라 이루어지며 한 번에 누적된 전체 합계를 의미하지 않습니다 (예: 고객이 금고에 US $50를 예치한 다음 추가로 US $100를 예치한 경우 고객은 US $150를 한 번에 반환할 수 없으며, 원래 예치한 금액만큼 따로 반환할 수 있습니다); (iii) 계정이 비활성화된 경우 금고에 예치된 사용 가능한 모든 자금은 회사에 의해 자동으로 계정의 자산으로 복원되며 비활동 수수료는 고객 계약 13.3항에 따라 공제됩니다. (iv) 회사는 적절하다고 판단되는 경우 금고사용을 거부하고 이용 약관을 변경 및 업데이트하여 이를 취소할 권리를 가집니다.
              <br><br>
              <b>비활동 수수료</b><br>
              12개월 이상 연속적으로 거래 활동이 없는 고객의 계정에는 분기 단위로 미화 15달러 또는 계정 순자산이 미화 15달러 미만인 경우에는 계정 순자산 전체가 비활동 수수료로 부과될 수도 있습니다.
              <br><br>
              <b>환전 수수료</b><br>
              고객의 거래 계정 통화와 다른 통화로 금융 상품을 거래할 경우 환전 수수료가 발생할 수도 있습니다.
              <br><br>
              신용카드를 사용하여 거래 계정 통화가 아닌 다른 통화로 자금을 입금하거나 출금하는 경우 고객 신용 카드 회사에서 부과하는 환전 수수료가 적용될 수 있습니다.
              <br><br>
              <b>특정 제한 국가의 거래 서비스 이용 불가 및 접근 불가</b><br>
              거래 플랫폼 및/또는 거래 서비스는 미국을 포함한 특정 제한 국가에서 가능하거나 제공되지 않습니다. 제한 국가 목록을 포함한 특정 제한 국가의 회사 서비스 또는 웹사이트의 사용, 액세스 제한에 대한 자세한 내용을 보려시면 <a href="/legal/restricted-countries" target="_blank" rel="noopener">여기</a>를 클릭해주시기 바랍니다.
              <br><br>
              거래에 대한 상세정보에 대해서는, 당사의 <a href="/legal/client_agreement.pdf" target="_blank" rel="noopener">회사의 고객 합의에</a>를 참조하십시오
              </p>
              `,
          data_id: "",
          content_after: "",
        },
      ],
    },
    {
      id: "forex",
      title: "포렉스",
      tabs: [
        {
          //id: "forex_overnight_financing",
          id: "tc-view-10",
          title: "오버나이트 금융비용 (Overnight Financing)",
          content_before: `
                  <p>iFOREX와 함께 레버리지를 사용하여 외환 CFD를 거래할 때, 고객님께서 오픈한 거래들은 매 거래일 말에 오버나이트 파이낸싱의 대상이 됩니다. 이 오버나이트 파이낸싱은 종목의 거래되는 기본 통화에 대한 관련 이자율을 기준을 기준으로 계산되고 마크업을 더하여, 입금 혹은 차감이 될 수 있습니다. 환율에 대한 가격할증은 0.75 %부터 시작하며, 장기 (매수) 포지션과 단기 (매도)포지션 사이에 차이가 있거나 더 높을 수 있습니다. 최신 오버 나이트 금융비용 레벨은 아래 표를 참조하십시오.
                  <br><br>
                  계산 된 오버나이트 파이낸싱 퍼센트가 양수인 경우 해당 금액이 고객님의 계정 잔액에 추가(입금)됩니다. 오버나이트 파이낸싱 퍼센트가 음수인 경우, 고객님의 계정 잔액에서 해당 금액이 차감된다는 것을 의미합니다.
                  <br><br>
                  새로운 거래를 오픈할 때나 지정가 주문을 할 때, 주문창에서 발견할 수 있는 도구에 있는 '시장 정보' 탭 안에서 오버나이트 파이낸싱 비율, 금액 및 관련 실행 시간을 확인할 수 있습니다. 고객님의 계좌에서 차감되거나 추가되는 오버나이트 파이낸싱을 계산하려면 오버나이트 파이낸싱 비율에 거래 규모를 곱하면 됩니다. 각 CFD에 대한 오버나이트 파이낸싱 과정의 실행 시간은 거래 양식의 '도구' 에서 '종목 정보'의 '오버나이트 파이낸싱 (GMT)'에 자세히 설명되어 있습니다. 종목의 오버나이트 파이낸싱의 계산 된 가치와 백분율이 1 일 동안 적용됩니다. 일주일에 5 일 거래되는 CFD는 전체 주말 기간을 커버하므로 기본 거래 주간의 마지막 날에 표시된 가치의 3 배의 가치로 적립되거나 차변에 기입됩니다. 오버나이트 파이낸싱 금액은 CFD의 통화에 따라 계산됩니다. 그러나, 인용된 CFD의 통화가 계좌 통화와 다른 경우 계좌의 통화로 변환됩니다.
                  <br><br>
                  <u><b><u>공식</u></b></u><br><br>
                  매수할 때 오버나이트 파이낸싱 퍼센트 계산 (롱 포지션):
  
                    <div class="formula formula_f1">
                        <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">기타 화폐의 3개월 중반부 이자율 - 기본 통화의 3개월 중반부 이자율 + 롱 마크업</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>
                  <br>
                    매도할 때 오버나이트 파이낸싱 퍼센트 계산 (쇼트 포지션):
                    <br><br>
                      <div class="formula formula_f2">
                        <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">기타 화폐의 3개월 중반부 이자율 - 기본 통화의 3개월 중반부 이자율 - 숏 마크업</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                    </div>

                      <br><br>

                      오버나이트 파이낸싱 값을 계산하려면, 간단하게 비율에 거래 금액을 곱하면 됩니다:<br><br>오버나이트 파이낸싱 값 = 거래 금액 X 오버나이트 파이낸싱 퍼센트
                        <br><br><br>
                        <u><b><u>예제들</u></b></u><br><br>
                        <b>예 1</b><br><br>
                        이 예는 은행 간 금리 차이가 스프레드인상보다 높은 상황을 의미합니다. 이 경우 고객님께서 매수했을 때에는 계정에서 값이 차감되며, 매도를 했을 때에는 고객님의 계정으로 값이 추가됩니다:
                        <br><br>
                        <ul class="list-style-dashed mb-4">
                        <li>종목 = EUR / USD (유로 대 미국 달러)</li>
                        <li>EUR (기본 통화) 3개월 중반부 이자율 (연간) = -0.37 % = -0.0037</li>
                        <li>USD (기타 통화) 3개월 중반부 이자율 (연간) = 1.08 % = 0.0108</li>
                        <li>은행 간 금리 차이 = 1.45% = 0.0145</li>
                        <li>롱 마크업 = 0.75% = 0.0075</li>
                        <li>숏 마크업 = 0.75% = 0.0075</li>
                        <li>다른 통화로 표시된 거래 금액 = 106,550 USD (현재 마감가 기준으로 100,000EUR, 환율 1.0655)</li>
                        </ul>
                        매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):<br><br>
                      
                    <div class="formula formula_f3 mb-2" >
                        <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) + 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.0000611</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.00611%</div>
                    </div>

                    오버나이트 파이낸싱 값 = 106,550 × (-0.0000611) = -6.51 USD, 즉, 일일 6.51 USD의 부과됨을 의미
                    <br><br><br>
                    매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>
                      
                      <div class="formula formula_f4 mb-2" >
                        <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                        <div class="formula-equal" >=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - (-0.0037) - 0.0075</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">0.00001944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">0.001944%</div>
                    </div>

                    오버나이트 파이낸싱 값 = 106,550 × 0.00001944 = 2.07 USD의 추가금
                    <br><br><br>
                    <b>예 2</b><br><br>
                    이 예는 은행 간 금리 차이가 마크업보다 높은 상황을 의미하며 롱 마크업과 숏 마크업은 다릅니다. 이 경우 고객님의 포지션과 상관없이 매일 밤 값이 차감됩니다:
                    <br><br>
                    <ul class="list-style-dashed mb-4">
                       <li>종목 = EUR / TRY (유로 대 터키 리라)</li>
                       <li>EUR (기본 통화) 3개월 중반부 이자율 (연간) = -0.37 % = -0.0037</li>
                       <li>TRY (기타 통화) 3개월 중반부 이자율 (연간) = 22.75 % = 0.2275</li>
                       <li>은행 간 금리 차이 = 23.12% = 0.2312</li>
                       <li>롱 마크업 = 0.75% = 0.0075</li>
                       <li>숏 마크업 = 14.00% = 0.14</li>
                       <li>다른 통화로 표시된 거래 금액 = 620,000 TRY (현재 마감가 기준으로 100,000EUR, 환율 6.2000)</li>
                    </ul>
                    매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):<br><br>
                    
                        <div class="formula formula_f5 mb-2" >
                            <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.000663</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.0663%</div>
                        </div>

                    
                        오버나이트 파이낸싱 값 = 620,000 × (-0.000663) = -411 TRY, 즉, 일일 411 TRY의 부과됨을 의미 (≅80 USD)
                        <br><br><br>
                        매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>
                      
                      <div class="formula formula_f6 mb-2" >
                            <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">0.2275 - (-0.0037) - 0.14</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.000253</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.0253%</div>
                        </div>


                        오버나이트 파이낸싱 값 = 620,000 × (0.000253) = 157 TRY, 즉, 일일 157 TRY의 추가금 (≅30 USD)
                        <br><br><br>
                        <b>예 3</b><br><br>
                        이 예는 은행 간 금리 차이가 가격할증(네거티브 마크업)보다 낮아지는 상황을 의미합니다. 이 경우 고객님께서 매도했을 때에는 계정에서 값이 차감되며, 매수를 했을 때에는 고객님의 계정으로 값이 추가됩니다.
                        <ul class="list-style-dashed mt-4 mb-4">
                           <li>종목 = USD/JPY (대 미국 달러 로 대 일본 엔)</li>
                           <li>USD (기본 통화) 3개월 중반부 이자율 (연간) = 1.08% = 1.08</li>
                           <li>JPY (기타 통화) 3개월 중반부 이자율 (연간) = -0.09% = -0.0009</li>
                           <li>은행 간 금리 차이 = -1.17% = -0.0117</li>
                           <li>롱 마크업 = 0.75% = 0.0075</li>
                           <li>숏 마크업 = 0.75% = 0.0075</li>
                           <li>다른 통화로 표시된 거래 금액 = 10,341,000 JPY (현재 마감가 기준으로 100,000USD, 환율 103.41)</li>
                        </ul>
                        매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):<br><br>
                      
                      
                      <div class="formula formula_f7 mb-2" >
                            <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">-
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 + 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">0.00001167</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">0.001167%</div>
                        </div>


                        오버나이트 파이낸싱 값 = 10,341,000 × 0.00001167 = 일일 120.65 JPY의 추가금 (≅1.1 USD)
                        <br><br><br>
                        매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>
                      
                      <div class="formula formula_f8 mb-2" >
                            <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f1">
                                <div class="formula-sub">
                                    <div class="formula-sub1">(-0.0009) - 0.0108 - 0.0075</div>
                                    <div class="formula-sub2">360</div>
                                </div>
                            </div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f2">-0.0000533</div>
                            <div class="formula-equal">=</div>
                            <div class="formula-f3">-0.00533%</div>
                        </div>

                        오버나이트 파이낸싱 값 = 10,341,000 × (-0.0000533) = -551.52 JPY, 즉, 일일 551.52 JPY의 부과됨을 의미 (≅5.3 USD)
                     
                      
                   
                  </p>`,
  
          data_id: "OvernightFinancing",
          content_after: `<p>* 거래일 종료 시점에 익일 차입금 정산은 최대 15분까지 소요될 수 있으며 정산 이후에는 계좌 잔액이 적절하게 적립 혹은 차감됩니다.</p>`,
          table_titles: [
            "종목",
            "일일 오버나이트 파이낸싱 퍼센트 (매도)",
            "일일 오버나이트 파이낸싱 퍼센트 (매수)",
            "오버나이트 파이낸싱 (GMT)*",
          ],
          view_id: ["Forex"],
        },
      ],
    },
    {
      id: "index_commodity_and_crypto_cfds",
      title: "지수,원자재 및 전자화폐 차액정산계약(CFD)",
      tabs: [
        {
          //id: "index_overnight_financing",
          id: "tc-view-11",
          title: "오버나이트 금융비용 (Overnight Financing)",
          content_before: `
              <p>
                  iFOREX에서 지수, 원자재 그리고 암호화폐 CFD 거래 시, 개시되어 있는 거래는 각 거래일 종료 시 오버나이트 파이낸싱의 대상이됩니다. 해당 오버나이트 파이낸싱은 기초 상품이 거래되는 통화에 대한 관련 이자율과 가격인상(mark-up)을 기준으로 계산되어 인출 또는 입금의 대상이 될 수 있습니다. 암호화폐의 가격인상은 암호화폐의 극심한 시장 조건으로 인해 훨씬 ​​더 높을 수 있습니다. 최신 오버나이트 파이낸싱 레벨에 대한 정보는 아래 표를 참조해주십시오.
                    <br><br>
                    계산 된 오버나이트 파이낸싱 퍼센트가 양수인 경우 해당 금액이 고객님의 계정 잔액에 추가(입금)됩니다. 오버나이트 파이낸싱 퍼센트가 음수인 경우, 고객님의 계정 잔액에서 해당 금액이 차감된다는 것을 의미합니다.
                    <br><br>
                    새로운 거래를 오픈할 때나 지정가 주문을 할 때, 주문창에서 발견할 수 있는 도구에 있는 '시장 정보' 탭 안에서 오버나이트 파이낸싱 비율, 금액 및 관련 실행 시간을 확인할 수 있습니다. 고객님의 계좌에서 차감되거나 추가되는 오버나이트 파이낸싱을 계산하려면 오버나이트 파이낸싱 비율에 거래 규모를 곱하면 됩니다. 각 CFD에 대한 오버나이트 파이낸싱 과정의 실행 시간은 거래 양식의 '도구' 에서 '종목 정보'의 '오버나이트 파이낸싱 (GMT)'에 자세히 설명되어 있습니다. 종목의 오버나이트 파이낸싱의 계산 된 가치와 백분율이 1 일 동안 적용됩니다. 일주일에 5 일 거래되는 CFD는 전체 주말 기간을 커버하므로 기본 거래 주간의 마지막 날에 표시된 가치의 3 배의 가치로 적립되거나 차변에 기입됩니다. 오버나이트 파이낸싱 금액은 CFD의 통화에 따라 계산됩니다. 그러나, 인용된 CFD의 통화가 계좌 통화와 다른 경우 계좌의 통화로 변환됩니다.
                    <br><br>
                    <u><b><u>공식</u></b></u><br><br>
                    매수할 때 오버나이트 파이낸싱 퍼센트 계산 (롱 포지션):
            
                  <div class="formula formula_f9 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">3개월 금리 + 마크 업</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                  <br>
                매도할 때 오버나이트 파이낸싱 퍼센트 계산 (쇼트 포지션):<br><br>
                  
                  <div class="formula formula_f10 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">3개월 금리 - 마크 업</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>

                오버나이트 파이낸싱 값을 계산하려면, 간단하게 비율에 거래 금액을 곱하면 됩니다:<br><br>오버나이트 파이낸싱 값 = 거래 금액 X 오버나이트 파이낸싱 퍼센트
                <br><br><br>
                <u><b><u>예제들</u></b></u><br><br>
                <b>예 1</b><br><br>
                이 예는 은행 간 금리가 스프레드인상보다 높음을 나타냅니다. 이 경우 고객님께서 매수했을 때에는 계정에서 값이 차감되며, 매도를 했을 때에는 고객님의 계정으로 값이 추가됩니다:
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>종목 = 브라질 Ibovespa</li>
                   <li>브라질 레알 (BRL) 3개월 이자율 (연간) = 9.567 % = 0.09567</li>
                   <li>마크 업 = 2.5% = 0.025</li>
                   <li>통화로 표시된 거래 금액 = 127,380 BRL (현재 마감가 기준으로 2계약 지수, 계약 당 63690 BRL)</li>
                </ul>

                매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):<br><br>
                  
                  <div class="formula formula_f11 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 + 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0003351944</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.03351944%</div>
                </div>

                오버나이트 파이낸싱 값 = 127,380 × (-0.0003351944) = -42.70 BRL, 즉, 일일 42.70 BRL의 부과됨을 의미 (≅13.58 USD)
                <br><br><br>
                매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>
                  
                  <div class="formula formula_f12 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.09567 - 0.025</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.00019630556</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.019630556%</div>
                </div>

                오버나이트 파이낸싱 값 = 127,380 × 0.00019630556 = 일일 25 BRL 의 추가금 (≅7.95 USD)
                <br><br><br>
                <b>예 2</b><br><br>
                이 예는 은행 간 금리가 스프레드인상보다 낮음을 나타냅니다. 이 경우 고객님의 포지션과 상관없이 매일 밤 값이 차감됩니다:
                <br><br>
                <ul class="list-style-dashed">
                   <li>종목 = 오일 (Crude Light WTI)</li>
                   <li>미국 달러 (USD) 3개월 이자율 (연간) = 1.08 % = 0.0108</li>
                   <li>마크 업 = 2.5% = 0.025</li>
                   <li>통화로 표시된 거래 금액 = 53,250 달러 (현재 마감가 기준으로 1,000 배럴, 배럴당 53.25 USD)</li>
                </ul>
                <br><br>
                매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):
                  
                  <br><br>

                  <div class="formula formula_f13 mb-2">
                        <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">-
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 + 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00009944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.009944%</div>
                    </div>

                    오버나이트 파이낸싱 값 = 53,250 × (-0.00009944) = -5.30 USD, 즉, 일일 5.30 USD의 부과됨을 의미
                    <br><br><br>
                    매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>
                  
                  <div class="formula formula_f14 mb-2">
                        <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f1">
                            <div class="formula-sub">
                                <div class="formula-sub1">0.0108 - 0.025</div>
                                <div class="formula-sub2">360</div>
                            </div>
                        </div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f2">-0.00003944</div>
                        <div class="formula-equal">=</div>
                        <div class="formula-f3">-0.003944%</div>
                    </div>

                    오버나이트 파이낸싱 값 = 53,250 × (-0.00003944) = -2.10 USD, 즉, 일일 2.10 USD의 부과됨을 의미
                  <br><br>
                  
                 
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* 거래일 종료 시점에 익일 차입금 정산은 최대 15분까지 소요될 수 있으며 정산 이후에는 계좌 잔액이 적절하게 적립 혹은 차감됩니다.</p>`,
          table_titles: [
            "종목",
            "일일 오버나이트 파이낸싱 퍼센트 (매도)",
            "일일 오버나이트 파이낸싱 퍼센트 (매수)",
            "오버나이트 파이낸싱 (GMT)*",
          ],
          view_id: ["Index", "Commodity", "Crypto"],
        },
        {
          //id: "contracts_rollover_dates",
          id: "tc-view-3",
          title: "계약 롤오버 일정",
          content_before: `<p>
                    미래 계약 (즉, 상품 및 지표)을 기반으로하는 모든 CFD는 롤오버 날짜가 있습니다.
                    <br><br>
                    관련 종목의 롤오버 날짜에 도달하면 열려있는 모든 향후 CFD 포지션이 다음 계약으로 롤오버되어 새로운 미래 계약으로 포지션이 유지됩니다.
                    <br><br>
                    롤오버를 실행하게 된다면 거래한 포지션들의 P/L (손익)은 종료된 계약 가격과 새 계약 가격의 가격 차이를 나타내며 스프레드인상된 스프레드를 포함합니다. 모든 관련된 지정가 주문 수준은 새로운 미래 계약 가격에 따라 자동으로 조정됩니다.
                    <br><br>
                    예를 들어, WTI Oil의 2 월 계약의 최종 가격은 $50.125이고 현재 계약(3 월)의 시장 가격이 $50.805 이면 모든 지정가 주문의 가격 수준이 $0.68만큼 상향 조정됩니다.
                    <br><br>
                    계약의 롤오버 날짜는 고객님께서 거래하는 종목에 따라 다르며, 아래에 명시된 롤오버 날짜는 iFOREX의 CFD 에 적용되는 유일한 롤오버 날짜입니다:
                  </p>`,
  
          data_id: "FuturesRollover",
          content_after: ``,
          table_titles: ["계약 월", "계약 롤오버 (GMT)"],
          view_id: ["Commodity", "Index"],
          products: ["원자재", "지수"],
        },
      ],
    },
    {
      id: "Share and ETF CFDs",
      title: "주식 및 ETF CFD",
      tabs: [
        {
          //id: "shares_overnight_financing",
          id: "tc-view-12",
          title: "오버나이트 금융비용 (Overnight Financing)",
          content_before: `<p>
                     iFOREX에서 주식 및 ETF CFD 거래 시, 개시되어 있는 거래는 각 거래일 종료 시 오버나이트 파이낸싱의 대상이됩니다. 해당 오버나이트 파이낸싱은 기초 상품이 거래되는 통화에 대한 관련 이자율과 가격인상(mark-up)을 기준으로 계산되어 인출 또는 입금의 대상이 될 수 있습니다. 최신 오버 나이트 파이낸싱 레벨에 대한 정보는 아래 표를 참조해주십시오.
                    <br><br>
                    계산 된 오버나이트 파이낸싱 퍼센트가 양수인 경우 해당 금액이 고객님의 계정 잔액에 추가(입금)됩니다. 오버나이트 파이낸싱 퍼센트가 음수인 경우, 고객님의 계정 잔액에서 해당 금액이 차감된다는 것을 의미합니다.
                    <br><br>
                    새로운 거래를 오픈할 때나 지정가 주문을 할 때, 주문창에서 발견할 수 있는 도구에 있는 '시장 정보' 탭 안에서 오버나이트 파이낸싱 비율, 금액 및 관련 실행 시간을 확인할 수 있습니다. 고객님의 계좌에서 차감되거나 추가되는 오버나이트 파이낸싱을 계산하려면 오버나이트 파이낸싱 비율에 거래 규모를 곱하면 됩니다. 각 CFD에 대한 오버나이트 파이낸싱 과정의 실행 시간은 거래 양식의 '도구' 에서 '종목 정보'의 '오버나이트 파이낸싱 (GMT)'에 자세히 설명되어 있습니다. 종목의 오버나이트 파이낸싱의 계산 된 가치와 백분율이 1 일 동안 적용됩니다. 일주일에 5 일 거래되는 CFD는 전체 주말 기간을 커버하므로 기본 거래 주간의 마지막 날에 표시된 가치의 3 배의 가치로 적립되거나 차변에 기입됩니다. 오버나이트 파이낸싱 금액은 CFD의 통화에 따라 계산됩니다. 그러나, 인용된 CFD의 통화가 계좌 통화와 다른 경우 계좌의 통화로 변환됩니다.
                    <br><br>
                    <u><b><u>공식</u></b></u><br><br>
                    매수할 때 오버나이트 파이낸싱 퍼센트 계산 (롱 포지션):<br>
                  
                  <div class="formula formula_f15 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">3개월 금리 + 마크 업</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>
                매도할 때 오버나이트 파이낸싱 퍼센트 계산 (쇼트 포지션):<br><br>


                <div class="formula formula_f16 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">3개월 금리 - 마크 업</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                </div>
                <br>

                오버나이트 파이낸싱 값을 계산하려면, 간단하게 비율에 거래 금액을 곱하면 됩니다:<br><br>오버나이트 파이낸싱 값 = 거래 금액 X 오버나이트 파이낸싱 퍼센트
                <br><br><br>
                <u><b><u>예제들</u></b></u><br><br>
                <b>예 1</b><br><br>
                이 예는 은행 간 금리가 스프레드인상보다 높음을 나타냅니다. 이 경우 고객님께서 매수했을 때에는 계정에서 값이 차감되며, 매도를 했을 때에는 고객님의 계정으로 값이 추가됩니다:
                <br><br>
                <ul class="list-style-dashed">
                   <li>종목 = 가즈프롬 (GAZP)</li>
                   <li>러시아 루블 (RUB) 3개월 이자율 (연간) = 9.5 % = 0.095</li>
                   <li>마크 업 = 5% = 0.05</li>
                   <li>통화로 표시된 거래 금액 = 2,459,000 RUB (현재 마감가 기준으로 20,000 주, 주당 122.95 RUB)</li>
                </ul>
                <br><br>
                매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):<br><br>
                  
                  
                <div class="formula formula_f17 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.0004</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.04%</div>
                </div>

                오버나이트 파이낸싱 값 = 2,459,000 × (-0.0004) = -983.60 RUB, 즉, 일일 983.60 RUB의 부과됨을 의미 (≅17.52 USD)
                <br><br><br>
                매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>

                  <div class="formula formula_f18 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal" >=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.095 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">0.000125</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">0.0125%</div>
                </div>


                오버나이트 파이낸싱 값 = 2,459,000 × 0.000125 = 일일 307.38 RUB 의 추가금 (≅5.48 USD)
                <br><br><br>
                <b>예 2</b><br><br>
                이 예는 은행 간 금리가 스프레드인상보다 낮음을 나타냅니다. 이 경우 고객님의 포지션과 상관없이 매일 밤 값이 차감됩니다:<br>
                <br><br>
                <ul class="list-style-dashed mb-4">
                   <li>종목 = Apple (AAPL)</li>
                   <li>미국 달러 (USD) 3개월 이자율 (연간) = 1.08 % = 0.0108</li>
                   <li>마크 업 = 5% = 0.05</li>
                   <li>통화로 표시된 거래 금액 = 70,600 USD (현재 마감가 기준으로 500주, 주당 141.20 USD)</li>
                </ul>
          
                매수할 때 오버나이트 파이낸싱 퍼센트 (롱 포지션):
                <br><br>

                  <div class="formula formula_f19 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">-
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 + 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000169</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0169%</div>
                </div>
                  
                오버나이트 파이낸싱 값 = 70,600 × (-0.000169) = -11.93 USD, 즉, 일일 11.93 USD의 부과됨을 의미
                <br><br><br>
                매도할 때 오버나이트 파이낸싱 퍼센트 (쇼트 포지션):<br><br>
                  
                <div class="formula formula_f20 mb-2">
                    <div class="formula-name">오버나이트 파이낸싱 퍼센트</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f1">
                        <div class="formula-sub">
                            <div class="formula-sub1">0.0108 - 0.05</div>
                            <div class="formula-sub2">360</div>
                        </div>
                    </div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f2">-0.000109</div>
                    <div class="formula-equal">=</div>
                    <div class="formula-f3">-0.0109%</div>
                </div>


                오버나이트 파이낸싱 값 = 70,600 × (-0.000109) = -7.70 USD, 즉, 일일 7.70 USD의 부과됨을 의미
            
              </p>`,
          data_id: "OvernightFinancing",
          content_after: `<p>* 거래일 종료 시점에 익일 차입금 정산은 최대 15분까지 소요될 수 있으며 정산 이후에는 계좌 잔액이 적절하게 적립 혹은 차감됩니다.</p>`,
          table_titles: [
            "종목",
            "일일 오버나이트 파이낸싱 퍼센트 (매도)",
            "일일 오버나이트 파이낸싱 퍼센트 (매수)",
            "오버나이트 파이낸싱 (GMT)*",
          ],
          view_id: [ "Shares", "ETF"],
        },
        {
          //d: "dividends",
          id: "tc-view-7",
          title: "배당금",
          content_before: `<p>
                        주식 CFD과 관련하여 현금 배당을 분배하는 경우 배당금 조정은 배당락일 전의 영업일 종료 시에 고객이 보유한 기초 주식의 CFD 포지션과 관련하여 고객 잔액에 대해 이루어집니다. 배당금 조정은 배당금의 크기, 고객 포지션의 크기, 매수 또는 매도 거래 여부 등에 따라 계산되어야 하며, 이로써 롱 포지션에서는 조정이 고객 잔고에 적립되어야 하며, 숏 포지션에서는 조정이 고객의 잔액에서 차감되어야 합니다. 배당금은 기초 주식의 거래 시간 외에 주식의 다음 거래일이 시작되기 전에 고객의 잔고에서 적립되거나 차감되어야하며, 배당 조정 시에 고객의 각 포지션 보유를 조건으로 합니다. 이 기간 동안, 다음 거래일이 개장될 때까지 고객 주식의 공정 가치를 유지하기 위해 회사는 고객 잔액에서 차감되거나 적립된 배당 금액에 따라 고객의 포지션을 조정해야 합니다.
                        <br><br>
                        <u>예시:</u><br>
                        코카콜라는 주당 0.35 달러의 배당금을 발행합니다.<br>
                        배당 기일은 11 월 29 일이며 iFOREX 의 결재일은 11 월 28 일 22:05 GMT입니다.<br>
                        결재 전 마감 가격은 41.65입니다.<br>
                        5,000주의 롱 포지션을 보유한 고객은 자신의 거래가 결제일에 미결제 상태이면 0.35 x 5000 = 1750 USD로 적립될 것입니다.
                        <br>
                        고객이 숏 포지션을 보유하고 있는 경우, 해당 고객의 거래 계좌 잔고에서 유사한 금액이 차감될 것입니다.
                        <br>
                        마지막 주가에서 배당금을 뺀 금액과 같은 41.65에서 41.30 로 주가가 조정됩니다.
                      </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"현재 미래 배당금에 대한 정보가 없습니다.",
          table_titles: [
            "주식 / 상장지수펀드(ETF)",
            "시장",
            "배당 금액",
            "날짜 및 시간 (GMT)",
          ],
          view_id: "1",
        },
        {
          //id: "corporate_actions",
          id: "tc-view-1",
          title: "주식 분할 및 기타 기업 행위",
          content_before: `<p>
                기업 행위는 공개 회사의 주가에 영향을 미치는 특정 이벤트입니다. 특정 기업 행위와 관련하여 본 문서에서 달리 언급하지 않는 한 특정 주식의 기업 행위 발생 시 필요한 경우 아이포렉스는 해당 CFD의 지정가 주문 제거를 포함하여 관련 차액정산계약(CFD)의 모든 미결제 포지션을 청산할 것입니다.
                <br><br>
                iFOREX의 기업 행위에는 권리 제공, 상장 폐지 및 주식 가격 (기업 중요 발표, 인수, 합병, 파산 등을 포함)에 중대한 영향을 미칠 수있는 기타 사건이 포함됩니다.
                <br><br>
                <strong>
                주식 분할 및 주식 병합 관련 특정 규칙
                </strong>
                <br>
                주식 분할 및 주식 병합은 주식을 보유한 사람들의 주식 총액을 변경하는 것이 아니라 주식의 수와 가격을 변경합니다. 이러한 분할은 일반적으로 주가가 너무 높거나 낮을 때 구현됩니다. 개시되어 있는 거래 및 한도 거래가 있을 때 주식 분할이 이루어질 경우 이에 따라 금액, 요율 및 관련 한도 수준이 조정됩니다 (해당하는 경우 필수 PL 조정으로 인한 계정 잔액 포함).
                <br><br>
                예를 들어, 1:10 분할에서 1주는 10주가 되고 가격은 10으로 나누어 전체 주식 가치는 변하지 않습니다. 예를 들어, 가격이 $1,000인 주식 1개는 이후 가격이 $100인 주식 10개가 됩니다. 즉, 1x $1,000 = 10 x $100 = $1,000 가 되는 것입니다.
                <br><br>
                다가오는 기업 행위 목록을 아래에서 확인해주세요.
              </p>`,
          data_id: "CorporateActions",
          content_after: "",
          no_information:"현재 미래의 기업 행동에 대한 정보가 없습니다",
          table_titles: ["주식 / 상장지수펀드(ETF)", "시장", "종목", "날짜 및 시간 (GMT)"],
        },
        {
          //id: "earnings_reports",
          id: "tc-view-22",
          title: "실적 발표",
          content_before: `<p>
                        실적 발표는 공기업들이 성과를 보고하기 위해 정기적으로 작성하는 서류입니다. 분기별 실적 분석을 통해 투자자는 기업의 재무 건전도를 분석할 수 있습니다. 시가 총액이 높은 인기 기업의 실적 발표는 주가에 영향을 미칠 수 있으며, 이러한 실적 발표가 공개될 때 불과 며칠 사이에도 급격한 주가 변동이 발생하기도 합니다.
                        <br><br>
                        이러한 이유로 해당 주식의 최대 노출액은 발행 기간 내내 10,000달러로 낮아질 것입니다.
                        </p>`,
          data_id: "",
          content_after: "",
        },
      ],
    },
  ];
  
  export { content };
  